import { Link } from "react-router-dom";
import Navbar from "../shared/components/Navbar";
import Footer from "../shared/components/Footer";
import FAQAccordion from "../shared/components/FAQAccordion";
import { useState } from "react";
import { subscribeEmail } from "../../services/api";
import toast from "react-hot-toast";

export default function Home() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate email
    if (!email.trim()) {
      toast.error("Please enter an email address");
      return;
    }
    
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await subscribeEmail(email);
      toast.success("Thank you for subscribing!");
      setEmail(""); // Clear the input field
    } catch (error) {
      toast.error(error.message || "Failed to subscribe. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen text-white"
      style={{
        background: "url('/imgs/bg-galaxy.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundBlendMode: "overlay",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
      }}>
      <Navbar />
      {/* Hero Section */}
      <div className="text-center py-8 px-6">
        <div className="bg-blue-500/50 text-white py-2 px-4 rounded-full inline-flex items-center space-x-2 mb-6">
          <img src="/imgs/sparcle.png" alt="✨" />
          <span>Transcribe Audio to Text</span>

          <img src="/imgs/sparcle.png" alt="✨" />
        </div>
        <h1 className="text-6xl font-bold text-primary mb-4">
          TABLETOP RECORDER
        </h1>
        <p className="text-xl text-white font-semibold mb-12">
          Automating Campaign Notes for RPGs
        </p>
      </div>
      {/* Less buy work more start */}

      <div className="container mx-auto flex flex-col-reverse items-center md:flex-row gap-12 px-2 md:px-8">
        <div className="w-100 md:w-1/2">
          <h3 className="text-3xl lg:text-4xl font-bold pt-6 pb-10">
            Less Busy Work, More Dragon Slaying
          </h3>
          <ul className="custom-bullet">
            <li className="mb-2">
              AI that Transcribes And Summarizes Sessions
            </li>
            <li className="mb-2">Keep Players Immersed in the Moment</li>
            <li className="mb-2">To Simplify TTRPG Storytelling</li>
            <li className="mb-2">And Maintain Player Immersion</li>
          </ul>
          <p className="font-bold text-2xl my-8">
            Support the Tabletop Recorder Kickstarter
          </p>
          <Link
            to="https://www.kickstarter.com/projects/tabletoprecorder/tabletop-recorder-automate-ttrpg-notes"
            className="bg-primary hover:bg-primary-light py-3 px-16 rounded-lg text-lg font-medium">
            Follow
          </Link>
        </div>
        <div className="w-100 md:w-1/2">
          <img
            src="/imgs/wsmain.png"
            alt="Stop Note-Taking From Spoiling Your Session"
            className="mx-auto p-4 md:p-1 rounded-[24px]"
          />
        </div>
      </div>
      {/* Less buy work more end */}
      <div className="py-10 md:py-20"></div>
      {/* Not to be stuck start */}
      <div className="container mx-auto flex flex-col md:flex-row-reverse gap-12 items-center px-2 md:px-8">
        <div className="w-100 md:w-1/2">
          <h3 className="text-3xl lg:text-4xl  font-bold pt-6 pb-10">
            No One Wants to be Stuck <br className="hidden lg:block" />
            Taking All the Notes…
          </h3>
          <p className="mb-3">
            Note-taking is an essential part of any long-term TTRPG adventure.
            Without notes, the plots don't make sense, NPCs get forgotten, and
            campaigns get confusing and abandoned
          </p>
          <p className="font-bold mb-3">
            But the open, ugly secret is this...NO ONE WANTS TO DO IT.
          </p>
          <p className="mb-3">
            When you take notes you necessarily stop chatting, imagining, and
            laughing with friends. It's everyday busy work, the kind of thing
            that compels people to escape into a fantasy world in the first
            place. Which begs the question: what is it doing staining every
            session of adventure?
          </p>
        </div>
        <div className="w-100 md:w-1/2">
          <img
            src="/imgs/side-2.webp"
            alt="Taking notes"
            className="mx-auto p-4 md:p-1"
          />
        </div>
      </div>
      {/* Not to be stuck end */}

      <div className="py-10 md:py-20"></div>

      {/* Video section start */}
      <div className="container mx-auto px-2 md:px-8">
        <h3 className="text-3xl lg:text-4xl text-center font-bold pt-6 pb-10">
          Hundreds of Pages of Notes…
          <br />
          Replaced with a Single Click
        </h3>
        <div className="overflow-hidden rounded-md mb-8">
          {/* <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/FsrMPexJkI4?si=88RavtHKOFvi1s5l"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen></iframe> */}
            <img 
            src="/imgs/TTR27.png" 
            alt="The Ultimate NoteTaker"
            className="w-full h-[500px] object-contain mx-auto rounded-[24px]" />
        </div>
        <p className="mb-3 text-center mx-auto w-100 md:w-[80%]">
          Tabletop Recorder helps players and DMs frustrated with the process of
          note taking by serving as their personal "unseen servant" scribe. Our
          AI- powered tool downloads audio of your session and organizes
          information on relevant characters and events, guaranteeing nothing
          important to your campaign will be neglected or forgotten
        </p>
        <p className="font-bold text-center my-8">
          Support the Tabletop Recorder Kickstarter
        </p>
        <div className="text-center mb-4">
          <Link
            to="https://www.kickstarter.com/projects/tabletoprecorder/tabletop-recorder-automate-ttrpg-notes"
            className="bg-primary mx-auto hover:bg-primary-light py-3 px-16 rounded-lg text-lg font-medium">
            Follow
          </Link>
        </div>
      </div>
      {/* Video section end */}
      <div className="py-10 md:py-20"></div>

      {/* Notetaker start */}
      <div className="container mx-auto flex flex-col items-center md:flex-row-reverse gap-12 px-2 md:px-8">
        <div className="w-100 md:w-1/2">
          <h3 className="text-3xl lg:text-4xl font-bold pt-6 pb-10">
            A Notetaker that Never Gets Distracted So Players Never Miss a
            Moment
          </h3>
          <p className="mb-3">
            The unique promise of TTRPGs is that you not only tell your own
            story, but LIVE your own adventure. Tabletop Recorder chronicles
            everything that takes place during a session, allowing everyone to
            stay present at the table and immerse themselves in magic of
            storytelling.
          </p>
        </div>
        <div className="w-100 md:w-1/2">
          <img
            src="/imgs/candid1.png"
            alt="Stop Note-Taking From Spoiling Your Session"
            className="mx-auto p-4 md:p-1 rounded-[24px]"
          />
        </div>
      </div>
      {/* Notetaker end */}
      <div className="py-10 md:py-20"></div>
      {/* Dominant Details start */}
      <div className="container mx-auto flex flex-col md:flex-row gap-12 items-center px-2 md:px-8">
        <div className="w-100 md:w-1/2">
          <h3 className="text-3xl lg:text-4xl  font-bold pt-6 pb-10">
            Dominant Details Diligently Documented
          </h3>
          <p className="mb-3">
            Part of cooperative storytelling is deadly-serious drama interrupted
            with silly jokes and table talk. While this makes for great fun,
            your personal AI-scribe has the wisdom to filter the irrelevant
            social conversations and only organize the important moments on your
            behalf. Players can freely focus on exploring and encountering,
            knowing that everything that happens is being astutely chronicled.
          </p>
          <p className="font-bold mb-5">
            Support the Tabletop Recorder Kickstarter
          </p>

          <Link
            to="https://www.kickstarter.com/projects/tabletoprecorder/tabletop-recorder-automate-ttrpg-notes"
            className="bg-primary hover:bg-primary-light py-3 px-16 rounded-lg text-lg font-medium">
            Follow
          </Link>
        </div>
        <div className="w-100 md:w-1/2">
          <img
            src="/imgs/Speaker A.png"
            alt="Taking notes"
            className="mx-auto p-4 md:p-1"
          />
        </div>
      </div>
      {/* Dominant Details end */}
      <div className="py-10 md:py-20"></div>
      {/* Track Every Narrative start */}
      <div className="container mx-auto flex flex-col items-center md:flex-row-reverse gap-12 px-2 md:px-8">
        <div className="w-100 md:w-1/2">
          <h3 className="text-3xl lg:text-4xl font-bold pt-6 pb-10">
            Track Every Narrative Thread, Without the Headache
          </h3>
          <p className="mb-3">
            An epic, ambitious campaign… one lasting years of your life … ought
            to have a companion tool to monitor and make sense of the ever
            sprawling plot. Depending on the player's prompt, Tabletop Recorder
            can instantly present info on past plot points, characters, items,
            locations (and more!)
          </p>
        </div>
        <div className="w-100 md:w-1/2">
          <img
            src="/imgs/side-5.webp"
            alt="Stop Note-Taking From Spoiling Your Session"
            className="mx-auto p-4 md:p-1"
          />
        </div>
      </div>
      {/* Track Every Narrative end */}
      <div className="py-10 md:py-20"></div>

      {/* Session Summaries start */}
      <div className="container mx-auto flex flex-col items-center md:flex-row gap-12 px-2 md:px-8">
        <div className="w-100 md:w-1/2">
          <h3 className="text-3xl lg:text-4xl font-bold pt-6 pb-10">
            Session Summaries Without the Scribbling
          </h3>
          <p className="mb-3">
            No player wants to waste their free time scouring volumes of notes.
            And yet, no GM wants his players to miss the details they need to
            discover the adventure. Tabletop Recorder gets everyone on the same
            page by curating summaries to your play style, catching everyone up
            to speed and so they can jump right back into the story.
          </p>
        </div>
        <div className="w-100 md:w-1/2">
          <img
            src="/imgs/side-6.webp"
            alt="Session Summaries"
            className="mx-auto p-4 md:p-1"
          />
        </div>
      </div>
      {/* Session Summaries end */}
      <div className="py-10 md:py-20"></div>

      {/* Notetaker start */}
      <div className="container mx-auto flex flex-col items-center md:flex-row-reverse gap-12 px-2 md:px-8">
        <div className="w-100 md:w-1/2">
          <h3 className="text-3xl lg:text-4xl font-bold pt-6 pb-10">
            The Next Premium Tool For Serious TTRPG Campaigns
          </h3>
          <p className="mb-3">
            Our AI-powered scribe is ready to document your every tale, triumph,
            and tragedy. If you'd like it to accompany you on your journey, then
            apply your signature below and all updates, announcements, and
            details shall be revealed in due time.
          </p>
          <form className="flex flex-col gap-2 mt-8" onSubmit={handleSubmit}>
            <label htmlFor="yourEmail">Email</label>
            <input
              type="email"
              placeholder="Your email"
              className="w-100 px-4 py-2 bg-white text-slate-900 rounded-lg focus:outline-none"
              required
              value={email}
              onChange={handleEmailChange}
              disabled={isSubmitting}
            />
            <p className="text-xs">
              Do not fret; none shall be privy to your personal information, nor
              shall we keep you subscribed against your will!
            </p>
            <button
              type="submit"
              disabled={isSubmitting}
              className={`${
                isSubmitting 
                  ? 'bg-gray-500' 
                  : 'bg-primary hover:bg-primary-light'
              } py-2 mt-3 px-10 w-100 rounded-lg font-bold transition-colors`}
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe to our Newsletter'}
            </button>
          </form>
        </div>
        <div className="w-100 md:w-1/2">
          <img
            src="/imgs/side-7.webp"
            alt="Stop Note-Taking From Spoiling Your Session"
            className="mx-auto p-4 md:p-1"
          />
        </div>
      </div>
      {/* Notetaker end */}
      <div className="py-10 md:py-20"></div>

      {/* Turns Chaos start */}
      <div className="container mx-auto px-2 md:px-8">
        <h3 className="text-3xl lg:text-4xl text-center font-bold pt-6 pb-10">
          Turns Chaos into Chronicles—Automatically
        </h3>
        <div className="flex flex-col items-stretch md:flex-row gap-12 step-card-wrapper">
          <div className="w-100 md:w-1/3 step-card p-4 mx-12 md:mx-0 md:mt-20 flex flex-col gap-4 down-arrow relative">
            <img
              className="arrow hidden md:block"
              src="/imgs/arrow-down.webp"
              alt=""
            />
            <img
              className="sm-arrow block md:hidden"
              src="/imgs/right.webp"
              alt=""
            />
            <img src="/imgs/sword-and-shield.png" alt="" width={80} />
            <h5 className="font-bold text-2xl">Choose Your Adventure</h5>
            <p>Login and select a campaign from your dashboard</p>
          </div>
          <div className="w-100 md:w-1/3 step-card p-4 mx-12 md:mx-0 md:mt-20 flex flex-col gap-4 up-arrow relative">
            <img
              className="arrow hidden md:block"
              src="/imgs/arrow-up.webp"
              alt=""
            />
            <img
              className="sm-arrow block md:hidden"
              src="/imgs/left.webp"
              alt=""
            />
            <img src="/imgs/microphone.png" alt="" width={80} />
            <h5 className="font-bold text-2xl">Record your Session</h5>
            <p>
              Hit record and relax; if anything is said out loud, Tabletop
              Recorder won't miss it
            </p>
          </div>
          <div className="w-100 md:w-1/3 step-card p-4 mx-12 md:mx-0 md:mt-20 flex flex-col gap-4 relative">
            <img
              className="sm-arrow block md:hidden"
              src="/imgs/right.webp"
              alt=""
            />
            <img src="/imgs/uploading.png" alt="" width={80} />
            <h5 className="font-bold text-2xl">Upload the Audio</h5>
            <p>
              If you are using a separate recording app, upload the audio to
              your dashboard
            </p>
          </div>
        </div>
        <div className="py-7 md:py-20"></div>
        <div className="flex flex-col items-stretch md:flex-row gap-12 step-card-wrapper-2">
          <div className="w-100 md:w-1/3 step-card p-4 mx-12 md:mx-0 md:mt-20 flex flex-col gap-4 down-arrow relative">
            <img
              className="arrow hidden md:block"
              src="/imgs/arrow-down.webp"
              alt=""
            />
            <img
              className="sm-arrow block md:hidden"
              src="/imgs/left.webp"
              alt=""
            />
            <img src="/imgs/teleport.png" alt="" width={80} />
            <h5 className="font-bold text-2xl">Let the AI do its Thing</h5>
            <p>
              Take a quick 1-4 minute break while the AI processes your session.
            </p>
          </div>
          <div className="w-100 md:w-1/3 step-card p-4 mx-12 md:mx-0 md:mt-20 flex flex-col gap-4 up-arrow relative">
            <img
              className="arrow hidden md:block"
              src="/imgs/arrow-up.webp"
              alt=""
            />
            <img
              className="sm-arrow block md:hidden"
              src="/imgs/right.webp"
              alt=""
            />
            <img src="/imgs/summary.png" alt="" width={80} />
            <h5 className="font-bold text-2xl">Select a Summary</h5>
            <p>
              Tell the AI what kind of summary you desire; brief, moderate, or
              detailed
            </p>
          </div>
          <div className="w-100 md:w-1/3 step-card p-4 mx-12 md:mx-0 md:mt-20 flex flex-col gap-4 relative">
            <img src="/imgs/chatbot.png" alt="" width={80} />
            <h5 className="font-bold text-2xl"> Question Your AI Scribe</h5>
            <p>
              The Tabletop Recorder answers specific questions by searching
              through notes when the table is confused or curious.
            </p>
          </div>
        </div>
      </div>
      {/* Turns Chaos end */}
      <div className="py-10 md:py-20"></div>
      {/* System Agnostic Start */}
      <div className="container mx-auto px-2 md:px-8">
        <h3 className="text-3xl lg:text-4xl text-center font-bold pt-6 pb-10">
          A System Agnostic Scribe{" "}
        </h3>
        <p className="mb-3 text-center mx-auto w-100 md:w-[80%]">
          Our AI- tool is trained to decipher the nuances of different settings,
          mechanics, game play, and DM styles. So no matter what TTRPG you are
          playing, Tabletop Recorder can track, keep up, and comprehend.
        </p>

        <div className="flex flex-wrap items-stretch justify-around mt-12 flex-row gap-8">
          <div className="w-[140px]">
            <img src="/imgs/companies-logo-3.webp" alt="" />
          </div>
          <div className="w-[140px]">
            <img src="/imgs/companies-logo-4.webp" alt="" />
          </div>
          <div className="w-[140px]">
            <img src="/imgs/companies-logo-1.webp" alt="" />
          </div>
          <div className="w-[140px]">
            <img src="/imgs/companies-logo-5.webp" alt="" />
          </div>
          <div className="w-[140px]">
            <img src="/imgs/companies-logo-2.webp" alt="" />
          </div>
        </div>
      </div>
      {/* System Agnostic End */}
      <div className="py-10 md:py-20"></div>
      {/* Takes Notes start */}

      <div className="container mx-auto flex flex-col items-center md:flex-row-reverse gap-12 px-2 md:px-8">
        <div className="w-100 md:w-1/2">
          <h3 className="text-3xl lg:text-4xl font-bold pt-6 pb-10">
          A Tool That Takes Notes So You Can Role Play and Adventure
          </h3>
          <p className="mb-3">
            Like you, we've been disappointed how AI technology has been used to
            replace the soul lifting work of creatives everywhere. Tabletop
            Recorder is an A.I that knows its place: it silently assists from
            the shadows, manufacturing a manuscript so that the PEOPLE at the
            table can do the real magic: imagining, improvising, and telling
            their story.
          </p>
        </div>
        <div className="w-100 md:w-1/2">
          <img
            src="/imgs/candid2.png"
            alt="Stop Note-Taking From Spoiling Your Session"
            className="mx-auto p-4 md:p-1 rounded-[24px]"
          />
        </div>
      </div>
      {/* Takes Notes end */}
      <div className="py-10 md:py-20"></div>
      {/* Share Captured TTRPG start */}
      <div className="container mx-auto flex flex-col md:flex-row gap-12 items-center px-2 md:px-8">
        <div className="w-100 md:w-1/2">
          <h3 className="text-3xl lg:text-4xl  font-bold pt-6 pb-10">
            Share Your Captured TTRPG Memories
          </h3>
          <p className="mb-12">
            Our main hub for TTRPG community camaraderie is our Discord server.
            There you can deliberate ideal prompts and tell tales of players
            using their detailed notes to FINALLY follow the breadcrumbs and
            connect the dots of the story.
          </p>
          <Link
            to="https://discord.gg/mQm54QtgMH"
            className="bg-primary hover:bg-primary-light py-3 px-16 rounded-lg text-lg font-medium">
            Join our Discord Server
          </Link>
        </div>
        <div className="w-100 md:w-1/2">
          <img src="/imgs/side-9.webp" alt="" className="mx-auto p-4 md:p-1" />
        </div>
      </div>
      {/* Share Captured TTRPG end */}

      <div className="py-10 md:py-20"></div>
      {/* FAQ  Start */}
      <div className="container mx-auto md:px-8">
        <h3 className="text-3xl lg:text-4xl text-center font-bold pt-6 pb-10">
          FAQ
        </h3>
        <FAQAccordion />
      </div>
      {/* FAQ  End */}
      <div className="py-10 md:py-20"></div>
      {/* Don't Waste start */}
      <div className="container mx-auto flex flex-col md:flex-row-reverse gap-12 items-center px-2 md:px-8">
        <div className="w-100 md:w-1/2">
          <h3 className="text-3xl lg:text-4xl  font-bold pt-6 pb-10">
            Don't Waste A Second of Your Free Time Gazing Down at your Notes{" "}
          </h3>
          <p className="mb-3">
            When you get together with friends, everyone at the table should be
            present imagining,adventuring, and socializing. OurTabletop Recorder
            AI tool promises to take care of the busy work of note taking and
            summarizing so that your free time stays focused on fun instead of
            fact-checking!
          </p>
          <p className="mb-12 font-bold">
            Support the Tabletop Recorder Kickstarter
          </p>
          <Link
            to="https://www.kickstarter.com/projects/tabletoprecorder/tabletop-recorder-automate-ttrpg-notes"
            className="bg-primary hover:bg-primary-light py-3 px-16 rounded-lg text-lg font-medium">
            Follow
          </Link>
        </div>
        <div className="w-100 md:w-1/2">
          <img src="/imgs/side-10.webp" alt="" className="mx-auto p-4 md:p-1" />
        </div>
      </div>
      {/* Don't Waste end */}

      <div className="py-10 md:py-20"></div>

      <Footer />
    </div>
  );
}
